module.exports = "/images/reserved-2-year-seller.png?7d2c79861d4deea1b01b60796ce384c8";